import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grammar-in-use-exercise-form',
  templateUrl: './grammar-in-use-exercise-form.component.html',
  styleUrls: ['./grammar-in-use-exercise-form.component.scss']
})
export class GrammarInUseExerciseFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
